<template>
  <ul class="features">
    <li
      v-for="feature in features"
      :key="feature.titleKey"
      v-home-reveal
      :class="{ visual: feature.src }"
    >
      <img v-if="feature.src" :src="feature.src" :alt="t(feature.titleKey)" />
      <div class="copy">
        <h2>{{ t(feature.titleKey) }}</h2>
        <p>{{ t(feature.bodyKey) }}</p>
        <div v-if="feature.pointKeys?.length" class="points">
          <span v-for="key in feature.pointKeys" :key="key">{{ t(key) }}</span>
        </div>
      </div>
    </li>
  </ul>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { HOME_FEATURES } from './home.data';
import { vHomeReveal } from './home-reveal';

export default defineComponent({
  directives: {
    homeReveal: vHomeReveal,
  },
  setup() {
    const { t } = useI18n();

    return {
      t,
      features: HOME_FEATURES,
    };
  },
});
</script>
<style scoped lang="scss">
.features {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  list-style: none;
  margin: 0 0 56px;
  padding: 0;
  text-align: left;
}

.features li {
  padding: 16px 18px;
  border: 1px solid rgba(246, 243, 238, 0.16);
  border-radius: 22px;
  background: rgba(20, 16, 24, 0.28);
}

.visual {
  position: relative;
  grid-column: 1 / -1;
  padding: 0;
  overflow: hidden;
  min-height: min(48vh, 380px);
}

.visual img {
  display: block;
  width: 100%;
  height: min(48vh, 380px);
  object-fit: cover;
  object-position: center 42%;
  animation: drift-zoom 18s ease-in-out infinite alternate;
}

.visual .copy {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 56px 22px 18px;
  background: linear-gradient(
    to top,
    rgba(20, 16, 24, 0.92) 0%,
    rgba(20, 16, 24, 0.55) 58%,
    transparent 100%
  );
}

.visual h2 {
  margin: 0 0 8px;
  font-size: clamp(1.25rem, 2.4vw, 1.85rem);
  letter-spacing: -0.03em;
}

.visual p {
  max-width: 54ch;
  color: rgba(246, 243, 238, 0.88);
}

.points {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.points span {
  padding: 5px 10px;
  border-radius: 999px;
  border: 1px solid rgba(246, 243, 238, 0.18);
  font-size: 11px;
  letter-spacing: 0.04em;
  color: #f6f3ee;
  background: rgba(20, 16, 24, 0.48);
  backdrop-filter: blur(8px);
  transition: transform 0.3s ease, background 0.3s ease;
}

.points span:nth-child(1) {
  border-color: rgba(250, 73, 110, 0.45);
}

.points span:nth-child(2) {
  border-color: rgba(166, 126, 255, 0.45);
}

.points span:nth-child(3) {
  border-color: rgba(82, 219, 255, 0.45);
}

.points span:hover {
  transform: translateY(-2px);
  background: rgba(20, 16, 24, 0.7);
}

h2 {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.02em;
}

p {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: rgba(246, 243, 238, 0.72);
}

@media (max-width: 700px) {
  .visual,
  .visual img {
    min-height: 0;
    height: 280px;
  }
}

@keyframes drift-zoom {
  from {
    transform: scale(1);
  }

  to {
    transform: scale(1.06);
  }
}

@media (prefers-reduced-motion: reduce) {
  .visual img,
  .points span {
    animation: none;
    transition: none;
  }
}
</style>
